import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CreateHostLevel,
  CreateSenderLevel,
  uploadFile,
} from "../../DAL/create";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { fileUrl } from "../../Config/Config";
import { updateHostData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
export const EditHostLevel = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [inputs, setInputs] = useState({
    level: "",
    diamonds: "",
    image: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [type, setType] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value < 0 ? 0 : e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = async (e) => {
    setType(true);
    const value = e.target.files[0];
    setPreviewImage(URL.createObjectURL(value));
    setInputs((prev) => ({ ...prev, image: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs?.level == "") {
      enqueueSnackbar("Level field is required", { variant: "error" });
      return;
    }
    if (inputs?.diamonds == "") {
      enqueueSnackbar("RCoin field is required", { variant: "error" });
      return;
    }
    if (!inputs?.image) {
      enqueueSnackbar("Image field is required", { variant: "error" });
      return;
    }
    const formData = new FormData();
    formData.append("level", inputs?.level);
    formData.append("rcoin", inputs?.diamonds);
    formData.append("file", inputs?.image);
    const resp = await updateHostData(formData, state?.id);
    if (resp.data?.statusCode == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate("/hosts-list");
    } else {
      enqueueSnackbar(resp?.data?.message, { variant: "error" });
    }
  };

  useEffect(() => {
    setInputs({
      level: state?.level,
      image: state?.pictureUrl,
      diamonds: state?.rcoin,
    });
    setPreviewImage(state?.pictureUrl);
  }, []);
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/hosts-list")}
          />
          <Typography variant="h6">Edit Host Level</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "6px" }}>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Level *"
              type="number"
              value={inputs?.level}
              name="level"
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter RCoins *"
              type="number"
              value={inputs?.diamonds}
              name="diamonds"
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <Grid container spacing={2}>
              <Grid item lg={4}>
                <Typography>Upload Image *</Typography>
                <FormHelperText>Image Size(200X100)</FormHelperText>
              </Grid>
              <Grid item lg={2} sx={{ textAlign: "center" }}>
                {previewImage && (
                  <img
                    src={
                      type == true
                        ? previewImage
                        : fileUrl + inputs?.image
                    }
                    alt=""
                    style={{ width: "80%", height: "70px" }}
                  />
                )}
              </Grid>
              <Grid item lg={6} sx={{ textAlign: "end" }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  name="image"
                  onChange={handleImageUpload}
                />
                <label htmlFor="upload-button">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      background: "linear-gradient(to right, #5301d7, #008eca)",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
                textTransform: "none",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
